import { useDataStore } from '@/store/data';
import { NetworkIdType, TokenInfo } from '@sonarwatch/portfolio-core';
import { ComputedRef, watch } from 'vue';

type Params = {
  tokenInfos: ComputedRef<
    Partial<Record<NetworkIdType, Record<string, TokenInfo>>>[]
  >;
};

export default function useTokenInfos({ tokenInfos }: Params) {
  const dataStore = useDataStore();

  watch(tokenInfos, (newTokenInfos) => {
    newTokenInfos.forEach((tokenInfo) => {
      if (tokenInfo == null) return;
      for (const [networkId, tokenInfoRecord] of Object.entries(tokenInfo)) {
        if (tokenInfoRecord) {
          dataStore.pushTokenInfos(
            networkId as NetworkIdType,
            new Map<string, TokenInfo>(Object.entries(tokenInfoRecord)),
          );
        }
      }
    });
  });
}
